<div class="padding">
  @if (dataLoading()) {
    <app-loading-animation></app-loading-animation>
  }

  @if (dataAvailable() || dataEmpty()) {
    <app-table-template
      tableTitle="Documents"
      [showTitle]="true"
      [showSearch]="true"
      [showPagination]="true"
      [showToggle]="true"
      [hasCardView]="true"
      [columns]="columns()"
      [currentPage]="currentPage()"
      [sortedOn]="sortField()"
      [sortDescending]="sortOrder() === -1"
      [tableMinWidthInRem]="80"
      (sortChanged)="sort($event)"
      (searchChanged)="search($event)"
      (pageChanged)="page($event)"
      (cellClicked)="cellClicked($event)">
      <app-document-card [currentPage]="currentPage()" (buttonClicked)="downloadDocument($event)"></app-document-card>
    </app-table-template>
  }
</div>
